export const SET_TOP_RAIL_NAVIGATION = "SET_TOP_RAIL_NAVIGATION";

export function setTopRailNavigation(activeElementId) {
    return {type: SET_TOP_RAIL_NAVIGATION, activeElementId: activeElementId};
}
